<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>

      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>ADMINSTRACION DE RESPUESTA RECORDATORIO DE PAGO RECURRENTE </span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>CODIGO</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Búsqueda de Administracion
        </b-col>
      </b-row>

      <b-row>
        <b-col>

          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre de la Administracion"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtener"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right">
              <b-button v-b-tooltip.hover title="Agregar Administracion" variant="outline-success"
                        v-if="lst.length>0"><ArrayToTxt :lst = "lst"/>
              </b-button>
              <b-button v-b-tooltip.hover title="Agregar Administracion" variant="outline-success"
                        @click="agregar()" >Agregar Administracion
              </b-button>
            </b-col>

          </b-row>

        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    title="Modificar Administracion"
                    size="sm"
                    @click="modificar(row.item)"
                    variant="outline-warning"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button v-if="!row.item.registroActivo"
                          title="Activar Administracion"
                          variant="outline-danger"
                          size="sm"
                          @click="activar(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else
                          title="Desactivar Administracion"
                          variant="outline-danger"
                          size="sm"
                          @click="desactivar(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>

            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>


      </b-row>

    </b-container>


    <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
        scrollable
    >
      <b-form @submit.stop.prevent="guardar">
        <b-container fluid>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label for="clave">Clave
                  <validacion />
                </label>
                <b-input-group size="sm" class="mb-2" id="clave">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="clave" placeholder="Clave del Administracion"
                                v-model="$v.cfdi.clave.$model"
                                :state="validateState('clave')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group align="left">
                <label for="descripcion">Descripción</label>
                <b-input-group size="sm" class="mb-2" id="nombre">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-textarea name="descripcion" placeholder="Descripcion del Administrador"
                                   v-model="$v.cfdi.descripcion.$model"
                                   :state="validateState('descripcion')"
                                   rows="3"
                                   max-rows="6"
                  ></b-form-textarea>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group>
                <label for="tipoPersona">Tipo de persona</label>

                <b-form-checkbox
                    id="checkbox-1"
                    v-model="cfdi.personaFisica"
                    name="checkbox-1"
                >
                  Persona Fisica
                </b-form-checkbox>
                <b-form-checkbox
                    id="checkbox-2"
                    v-model="cfdi.personaMoral"
                    name="checkbox-2"
                >
                  Persona Moral
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="submitGuardar" :disabled="loaderAcciones">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                    <b-spinner small></b-spinner>
                    Cargando...
                </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import ArrayToTxt from "../../views/ArrayToTxt.vue";

export default {
  name: "administracionRespuesta",
  components: {
    Header,
    ArrayToTxt
  },
  mixins: [validationMixin],
  data: () =>{
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        {key: "idCfdi", label: "ID", sortable: true},
        {key: "clave", label: "Clave", sortable: true},
        {key: "descripcion", label: "Descripción", sortable: false},
        {key: "personaFisica", label: "Persona Fisica", sortable: false},
        {key: "personaMoral", label: "Persona Moral", sortable: false},
        "Acciones",
      ],
      paginaActual: 1,
      show: false,
      tituloModal: '',
      cfdi: {
        idCfdi: null,
        clave: null,
        descripcion: null,
        personaFisica: false,
        personaMoral: false
      },
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
      loaderAcciones: false,
      loader: false,
      lst: [],
    }
  },
  validations: {
    cfdi: {
      clave: {required},
      descripcion: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtener();
  },
  methods: {
    obtener(){
      this.loader = true;
      this.datosTabla = [];
      this.$http.post(this.$api + 'cfdi/obtener', this.filtro).then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.paginaActual=1;
                this.datosTabla.push(it)
              })
            }
          }
      ).finally(() => {
        this.loader = false;
      })
    },
    agregar() {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.cfdi = {
        idCfdi: null,
        clave: null,
        descripcion: null
      };
      this.tituloModal = 'Agregar CFDI';
      this.show = true;
    },
    modificar(item) {
      this.$nextTick(() => {
        this.$v.$reset()
      });
      this.cfdi = JSON.parse(JSON.stringify(item));
      this.tituloModal = 'Modificar Administracion';
      this.show = true;
    },
    submitGuardar() {
      this.$refs.submitGuardar.click();
    },
    guardar() {
      this.$v.cfdi.$touch();
      if (this.$v.cfdi.$anyError){
        return;
      }
      if (!this.$v.cfdi.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'administracionRespuesta/guardar', this.cfdi).then(respuesta => {
              if (respuesta.data.data) {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La Administracion Respuesta se registro correctamente",
                });
                this.filtro.palabraClave = this.cfdi.cfdi;
                this.obtener();
                this.show = false;
              }
            }
        ).catch(error => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "La Administracion Respuesta ya existe",
          });
        }).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }
    },
    activar(item) {
      this.$swal({
        icon: "error",
        text: "¿Está seguro de activar la Administracion Respuesta?",
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if(aceptar.value){
          this.$http.delete(this.$api + 'administracionRespuesta/activar?idCfdi=' + item.idCfdi).then(respuesta => {
            if(respuesta.data.data){
              this.datosTabla[this.datosTabla.indexOf(item)].registroActivo = true;
            }
          })
        }
      })
    },
    desactivar(item){
      this.$swal({
        icon: "warning",
        text: "¿Está seguro de desactivar la Administracion Respuesta?",
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if(aceptar.value){
          this.$http.delete(this.$api + 'administracionRespuesta/desactivar?idCfdi=' + item.idCfdi).then(respuesta => {
            if(respuesta.data.data){
              this.datosTabla[this.datosTabla.indexOf(item)].registroActivo = false;
            }
          })
        }
      })
    },
    validateState(name){
      const {$dirty, $error} = this.$v.cfdi[name];
      return $dirty ? !$error : null;
    },
    cerrarModal(){
      this.show = false;
    }
  }
}
</script>